import type { ChipDesignTokens, ChipTokenSections } from '@primeuix/themes/types/chip';

export const root: ChipTokenSections.Root = {
    borderRadius: '{borderRadius.full}',
    paddingX: '{utilitySemantic.spacing.medium.1}',
    paddingY: '{utilitySemantic.spacing.small.2}',
    gap: '{utilitySemantic.spacing.small.1}',
    transitionDuration: '{transitionDuration}'
};

export const image: ChipTokenSections.Image = {
    width: '1.5rem',
    height: '1.5rem'
};

export const icon: ChipTokenSections.Icon = {
    size: '1rem'
};

export const removeIcon: ChipTokenSections.RemoveIcon = {
    size: '0.875rem',
    focusRing: {
        width: '{focusRing.width}',
        style: '{focusRing.style}',
        color: '{focusRing.color}',
        offset: '{focusRing.offset}',
        shadow: '{formField.focusRing.shadow}'
    }
};

export const colorScheme: ChipTokenSections.ColorScheme = {
    light: {
        root: {
            background: '{extend.surfacesubtle}',
            color: '{text.color}'
        },
        icon: {
            color: '{text.color}'
        },
        removeIcon: {
            color: '{text.color}'
        }
    },
    dark: {
        root: {
            background: '{surface.800}',
            color: '{surface.0}'
        },
        icon: {
            color: '{surface.0}'
        },
        removeIcon: {
            color: '{surface.0}'
        }
    }
};

export default {
    root,
    image,
    icon,
    removeIcon,
    colorScheme
} satisfies ChipDesignTokens;
